import {vnModule_knockoutJS} from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import {XMLHttpRequestHandler} from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {header} from "./header";
import {googleInsights_template} from "../components/templates/googleInsights_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnAppZone } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone';

declare var ko: any;
declare var page: any;

export class googleInsights extends vnModule_knockoutJS{

    protected googleInsights_template: googleInsights_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected zoneHeader: vnAppZone | null;

    /**
     * @inheritDoc
     */
    protected getModuleName(): string{

        return 'googleInsights';
    }


    /**
     * @inheritDoc
     */
    public buildContent() : Array<Element>{

        this.zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = this.zoneHeader?.loadedModule;
        (<header>loadedModule).setHeaderTitle('Page Path Search');

        this.googleInsights_template = new googleInsights_template('googleInsights', this.viewModel, this)
        this.template = this.googleInsights_template;

        return [this.googleInsights_template.build()];
    }

    /**
     * @inheritDoc
     */
    public fillPage(): void{

        // scroll to top
        window.scrollTo(0, 0);

        this.googleInsights_template.buildDatePickerCalendar();
        
        // First get the presets
        this.getSearchPresetsListData();
    }

    protected getListFormData(): void{

        this.loadingIn(this.googleInsights_template.builtTemplate.querySelector("#report-results"));

        let subViewModel = this.googleInsights_template.getViewModelForRequest();

        let usrReq_url: string = '/api/googleInsights/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

        /**
     * Returns handler for filter request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onFilterRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                // Every 100 report loads, display the Plan upgrade promotion (to free plan accounts only)
                obj.zoneHeader?.loadedModule.showPlanPromo();
                    
                obj.updateFilters(responseParsed);

                obj.updateViewModelFromPath();

                obj.getPermalinksBySearchByDate();

                obj.getPermalinksIndicatorsBySearchByDate();

                obj.googleInsights_template.setDatesSelected();
            });

            obj.loadingOut(obj.googleInsights_template.builtTemplate.querySelector("#report-results"));
        }
    }


    /**
     * Update the filters.
     *
     * @param responseParsed
     */
    protected updateFilters(responseParsed: any): void{

        this.googleInsights_template.setBrandFilterItems(responseParsed.portfolios);
        this.googleInsights_template.setDynamicFilters(responseParsed.dynamicFiltersData);

    }

    public getPermalinksBySearchByDate(): void{

        this.loadingIn(this.googleInsights_template.builtTemplate.querySelector("#permalinksBySearchByDate-results"), true);

        let subViewModel = this.googleInsights_template.getViewModelForRequest();
        
        let baseApiUrl = '/api/googleInsights/permalinksBySearchByDate/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onPermalinksBySearchByDateRequestReturn.bind(this, baseApiUrl, 'getPermalinksBySearchByDate'), XMLHttpRequestHandler_requestType.GET, 'getPermalinksBySearchByDate');
            
    }

    public getPermalinksIndicatorsBySearchByDate(): void{

        this.loadingIn(this.googleInsights_template.builtTemplate.querySelector("#permalinksIndicatorsBySearchByDate-results"), true);

        this.googleInsights_template.clearTimelineAnnotatonData();

        let subViewModel = this.googleInsights_template.getViewModelForRequest();
        
        let baseApiUrl = '/api/googleInsights/permalinksIndicatorsBySearchByDate/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onPermalinksIndicatorsBySearchByDateRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getPermalinksIndicatorsBySearchByDate');
            
    }

    public getListDataForCSV(): void{

        this.loadingIn(this.googleInsights_template.builtTemplate.querySelector("#permalinksBySearchByDate-results"));

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.googleInsights_template.getViewModelForRequest();
        
        let baseApiUrl = '/api/googleInsights/permalinksBySearchByDateExport/get/';
        
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        
        this.XHRHdl = new XMLHttpRequestHandler(baseApiUrl,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onCSVDataRequestReturn;
        this.XHRHdl.execute();
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onPermalinksBySearchByDateRequestReturn(baseApiUrl, callIdentifier, req, obj): Function{

        return function(){

            if(req.request.readyState == 4){
                
                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);

                    obj.updatePermalinks(responseParsed.data.paginatedPermalinks);
                    obj.updatePermalinksTotalRow(responseParsed.data.permalinksTotalRow);
                    obj.updatePagination(responseParsed.totalCount);
                    obj.setResultInfo(baseApiUrl, callIdentifier, responseParsed.totalCount, responseParsed.totalPage);
                }
            }

            obj.loadingOut(obj.googleInsights_template.builtTemplate.querySelector("#permalinksBySearchByDate-results"), true);
        }
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onPermalinksIndicatorsBySearchByDateRequestReturn(req, obj): Function{

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateIndicatorsData(responseParsed.indicatorsData);
                obj.googleInsights_template.setTimelineAnnotationsData(responseParsed.timelineAnnotationsData);
                obj.googleInsights_template.updateIndicatorsGraphData();
            });

            obj.loadingOut(obj.googleInsights_template.builtTemplate.querySelector("#permalinksIndicatorsBySearchByDate-results"), true);
        };
    }

    protected onCSVDataRequestReturn(req, obj) {

        return function (){

            if(req.request.readyState == 4){
                
                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);

                    obj.exportCsvData(responseParsed);
                }
            }

            obj.loadingOut(obj.googleInsights_template.builtTemplate.querySelector("#permalinksBySearchByDate-results"));
        };
    }

    protected updatePermalinks(permalinksData) {
        
        this.googleInsights_template.setPermalinksData(permalinksData);
    }

    protected updatePermalinksTotalRow(permalinksTotalRow) {
        
        this.googleInsights_template.setPermalinksTotalRow(permalinksTotalRow);
    }

    protected updatePagination(totalCount) {

        this.googleInsights_template.updatePagination(totalCount);
    }

    protected updateIndicatorsData(indicatorsData): void{

        this.googleInsights_template.setIndicatorsData(indicatorsData);
    }

    protected exportCsvData(exportData): void{

        this.googleInsights_template.setCsvExportData(exportData);
        this.googleInsights_template.exportCsvData();
    }


     /**
     * Hook.
     *
     * Initiates data refresh.
     */
     public filterDropdownOnChange(element): void{

         this.getReportData();
    }

    protected filterDateOnChange(element) {

        this.googleInsights_template.setDatesSelected();
        this.getReportData();
    }

    protected filterSimpleOnChange(){

        this.getReportData();
    }

    protected filterMultipleSelectorOnChange(){

        this.getReportData();
    }

    protected filterSingleGroupSelectorOnChange(){

        this.getReportData();
    }

    /**
     * Hook.
     *
     * Cancels data request.
     */
    protected filterSimpleCancel(){

        if(this.XHRHdl){

            this.XHRHdl.cancelAndReset();
        }
    }

    public getReportData(): void{

        this.getPermalinksBySearchByDate();
        this.getPermalinksIndicatorsBySearchByDate();
    }

    protected setResultInfo(baseApiUrl, callIdentifier, totalCount, totalPage){

        let callHdl = this.getXHRHdl(baseApiUrl, callIdentifier);
        let execTime = Math.round((new Date().getTime() - callHdl.requestStartTime)/1000*100)/100;
        this.googleInsights_template.setResultInfo(totalCount, totalPage, execTime);
    }

    public updateFilterUrlWithoutCall(): void{

        let subViewModel = this.template.getViewModelForRequest();

        this.updateFilterUrl(null, subViewModel);
    }

    protected paginationOnPageClick(){

        this.getPermalinksBySearchByDate();
    }

    public onQuit(){

        for(let callKey in this.XHRHdls){

            this.XHRHdls[callKey].cancelAndReset();
        }
    }

    private getXHRHdl(baseURl, callIdentifier){

        let callKey =   baseURl + '-' + callIdentifier;

        return this.XHRHdls[callKey];
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword) {

        let subViewModel = this.googleInsights_template.getViewModelForRequest();
        subViewModel['filters']['keyword'] = keyword;
        subViewModel['filters']['filterId'] = id;

        let usrReq_url = '/api/googleInsights/autoCompleteSuggestions/get/';

        let usrReq_callback;
        usrReq_callback = this.onGetMultipleAutoCompleteSuggestionsReturn.bind(this, id);

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
        
    }

    protected onGetMultipleAutoCompleteSuggestionsReturn(filterId, req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){

                    (obj.googleInsights_template.setDynamicAutoCompleteMultiSelectFilterItems(filterId, responseParsed.data));
                }
            });
        };

    }


}


// WEBPACK FOOTER //
// ./js/modules/googleInsights.ts